/* eslint-disable no-shadow */
import { FormFields, FormValidationSchema } from '../../common/interfaces';

export enum RobotsFormInputs {
  Content = 'content'
}

export type RobotsFormFields = FormFields<typeof RobotsFormInputs>;

export type RobotsFormValidationSchema = FormValidationSchema<RobotsFormFields>;
